import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;

    const onKycStatusAdded = (selectedItems, selectedOption) => {
      setFiltersModel((prevState) => {
          return { ...prevState, kyc_status: [...(prevState.kyc_status || []), selectedOption.label] }
      })
    }

    const onKycStatusRemove = (selectedItems, removedOption) => {
      setFiltersModel((prevState) => {
          return { ...prevState, kyc_status: prevState.kyc_status.filter((label) => label !== removedOption.label) }
      })
    }

    const onBookingChange = (selectedItems, selectedOption) => {
      setFiltersModel((prevState) => {
        if (selectedOption.name == "null") {
          delete prevState["currently_on_booking"]
          return prevState;
        } else {
          return { ...prevState, currently_on_booking: selectedOption.label }
        }
      })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
          <Form.Group className="mb-3">
              <Form.Label>Kyc Status</Form.Label>
              <MultiSelectField
                  options={[
                    {
                      label: 'requested',
                      name: 'Requested'
                    },
                    {
                      label: 'kyc_validated',
                      name: 'Kyc Validated'
                    },
                    {
                      label: 'failed',
                      name: 'Failed'
                    },
                  ]}
                  fieldName="kyc_status"
                  stateModel={filtersModel}
                  labelAttr="name"
                  valueAttr="label"
                  displayValue="name"
                  onSelect={onKycStatusAdded}
                  onRemove={onKycStatusRemove}
              	/>
                <br/>
                <Form.Label>Booking</Form.Label>
              <MultiSelectField
                  options={[
                    {
                      label: "true" ,
                      name: 'On Booking'
                    },
                    {
                      label: "false",
                      name: "Not on Booking"
                    },
                    {
                      label: "null",
                      name: "None"
                    },
                  ]}
                  fieldName="currently_on_booking"
                  stateModel={filtersModel}
                  labelAttr="name"
                  valueAttr="label"
                  displayValue="name"
                  onSelect={onBookingChange}
                  singleSelect={true}
                />

          </Form.Group>
        </div>
    </Filters>
};

export default FiltersPartial;

